// small utility to handle loading data from the server into an observable,
// with observables to indicate current status.
// returns Promises from actions to allow chaining
import S from 's-js';
import { IAjax } from 'lib/Ajax';
import * as Promise from 'bluebird';

export type Loader = ReturnType<typeof Loader>;
export function Loader<T>(ajax : IAjax, url : string, target : (v : T) => void) {
    var client = ajax.Url<T>(url),
        loading = S.data(false),
        error = S.data(false),
        loaded = S.data(false),
        request : Promise<boolean> | null = null;
    
    return {
        Loading: loading,
        Loaded: loaded,
        Error: error,
        Load: load,
        Reload: reload
    };
    
    function load() {
        if (!request) reload();
        return request;
    }
    
    function reload() { 
        loading(true);
        return request = client.Get()
        .then(function (data) {
            S.freeze(function () {
                target(data);
                loaded(true);
            });
        })
        .error(error)
        .finally(function () { loading(false); });
    };
}


// WEBPACK FOOTER //
// ./lib/loader.ts